module.exports = __webpack_public_path__ + "static/media/influence.7ab74683.svg";